(function() {
  var header = document.querySelector('.section-header');
  if (!header) return;

  var lastKnownY = window.scrollY;
  var offsetTrackedY = 0;
  var scrollDownThreshold = 200;
  var scrollUpThreshold = 50;
  var safeZone = 100;
  var scrollDirection = '';
  var ticking = false;

  function onScroll() {
    var previousY = lastKnownY;
    var previousDir = scrollDirection;
    lastKnownY = window.scrollY;
    scrollDirection = previousY < lastKnownY ? 'down' : 'up';
    if (previousDir !== scrollDirection) offsetTrackedY = lastKnownY;
    if (!ticking) requestAnimationFrame(update);
    ticking = true;
  }

  function update() {
    ticking = false;

    if (window.innerWidth >= 768) {
      var stickyBar = document.querySelector('.collection-sticky-header');
      if (stickyBar) stickyBar.style.top = '';
    }

    var scrolled = lastKnownY >= safeZone;
    var scrolledDown = scrollDirection === 'down' && lastKnownY >= offsetTrackedY + scrollDownThreshold;
    var scrolledUp = scrollDirection === 'up' && lastKnownY <= offsetTrackedY - scrollUpThreshold;

    if (scrolledDown) {
      header.classList.add('header--scrolled');
      header.classList.remove('header--visible');
    } else if (scrolledUp || !scrolled) {
      header.classList.add('header--visible');
      header.classList.remove('header--scrolled');
    }

    var stickyBar = document.querySelector('.collection-sticky-header');
    if (stickyBar) {
      var headerHidden = header.classList.contains('header--scrolled') && !header.classList.contains('header--visible');
      stickyBar.style.top = headerHidden ? '0px' : '44px';
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  header.classList.add('header--visible');

// Read more for product description
function initReadMore() {
  var attempts = 0;
  function tryInit() {
    var desc = document.querySelector('.section-main-product .product-description');
    if (!desc) return;
    var firstP = desc.querySelector('p');
    if (!firstP) return;

    if (firstP.offsetWidth === 0 && attempts < 20) {
      attempts++;
      setTimeout(tryInit, 100);
      return;
    }

    var lineHeight = parseFloat(getComputedStyle(desc).lineHeight);
    var isMobile = window.innerWidth < 768;
    var fullText = firstP.textContent.trim();
    var words = fullText.split(' ');

    var wordLimit = isMobile ? 25 : 31;
    if (words.length <= wordLimit) return;

    if (desc.querySelector('.read-more-btn')) return;

    var truncatedText = words.slice(0, wordLimit).join(' ');

    if (!truncatedText) return;

    var originalHTML = desc.innerHTML;

    firstP.textContent = truncatedText;

    var dots = document.createElement('span');
    dots.textContent = '... ';

    var readMore = document.createElement('span');
    readMore.textContent = document.documentElement.lang.indexOf('sv') === 0 ? 'Läs mer' : 'Read more';    
    readMore.style.textDecoration = 'underline';
    readMore.style.cursor = 'pointer';

    var wrapper = document.createElement('span');
    wrapper.className = 'read-more-btn';
    wrapper.style.cursor = 'pointer';
    wrapper.appendChild(dots);
    wrapper.appendChild(readMore);
    firstP.appendChild(wrapper);

    var siblings = Array.prototype.slice.call(desc.children);
    siblings.forEach(function(el) {
      if (el !== firstP) el.style.display = 'none';
    });

    var expanded = false;
    readMore.addEventListener('click', function() {
      expanded = true;
      observer.disconnect();
      desc.innerHTML = originalHTML;
    });

    var observer = new MutationObserver(function() {
      if (!expanded && !desc.querySelector('.read-more-btn')) {
        attempts = 0;
        setTimeout(tryInit, 100);
      }
    });
    observer.observe(desc.parentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
}

initReadMore();
})();

// Collection swatch hover - swap product image
(function() {
  function initSwatchHover() {
    document.querySelectorAll('.product-card-swatch[data-linked-image]').forEach(function(swatch) {
      swatch.addEventListener('mouseenter', function(e) {
        e.preventDefault();
        var card = swatch.closest('.product-block');
        var img = card.querySelector('.product-block__image--active img.theme-img');
        if (!img) img = card.querySelector('.product-block__image--active img');
        if (!img) return;
        if (!img.dataset.originalSrc) {
          img.dataset.originalSrc = img.src;
          img.dataset.originalSrcset = img.srcset || '';
        }
        img.srcset = '';
        img.src = swatch.dataset.linkedImage;
      });

      swatch.addEventListener('mouseleave', function() {
        var card = swatch.closest('.product-block');
        var img = card.querySelector('.product-block__image--active img.theme-img');
        if (!img) img = card.querySelector('.product-block__image--active img');
        if (!img || !img.dataset.originalSrc) return;
        img.src = img.dataset.originalSrc;
        if (img.dataset.originalSrcset) img.srcset = img.dataset.originalSrcset;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchHover);
  } else {
    initSwatchHover();
  }
})();


document.addEventListener('click', function(e) {
  var link = e.target.closest('a[href*="live-chat"]');
  if (link) {
    e.preventDefault();
    Intercom('show');
  }
});

// Mobile nav title: show "Menu" on tier-1, tier-1 name on tier-2
(function() {
  function initMobileNavTitle() {
    var drawer = document.querySelector('.mobile-navigation-drawer');
    if (!drawer) return;
    var title = drawer.querySelector('.mobile-nav-title');
    if (!title) return;

    // Set default title
    title.textContent = 'Menu';

    // Watch for child-open class to update title
    var observer = new MutationObserver(function() {
      if (drawer.classList.contains('mobile-navigation-drawer--child-open')) {
        var openItem = drawer.querySelector('.navigation__tier-1 > .navigation__item--open > .navigation__link');
        if (openItem) {
          title.textContent = openItem.textContent.trim();
        }
      } else {
        title.textContent = 'Menu';
      }
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // Also listen for tier-1 link clicks to catch the name before class changes
    drawer.querySelectorAll('.navigation__tier-1 > .navigation__item > .navigation__children-toggle').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var item = toggle.closest('.navigation__item');
        var link = item.querySelector('.navigation__link');
        if (link) {
          title.textContent = link.textContent.trim();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNavTitle);
  } else {
    initMobileNavTitle();
  }
})();